import { client } from "service/service";

export const getSources = async (isDeleted: boolean) => {

  const isDeletedString = isDeleted ? "true" : "false";
  try {
    const res = await client.get(`sources?isDeleted=${isDeletedString}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const postSources = async (data: any) => {
  try {
    const res = await client.post(`sources`, data);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const patchSources = async (id: string, data: any) => {
  try {
    const res = await client.patch(`sources/${id}`, data);
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const deleteSources = async (id: string) => {
  try {
    const res = await client.delete(`sources/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}

